import App from "./app";
import Event from "./event";
import Expansions from "./expansions";
import Network from "./network";
import Preferences from "./preferences";
import Time from "./time";
import Translation from "./translation";
import User from "./user";
import Data from "./data";
import Rules from "./rules";
import Config from "./config";
import Lodash from "./lodash";
import intersectionObserverProvider from "./intersectionObserverProvider";

export default {

    install(Vue) {
        Vue.use(App);
        Vue.use(Event);
        Vue.use(Expansions);
        Vue.use(Network);
        Vue.use(Preferences);
        Vue.use(Time);
        Vue.use(Translation);
        Vue.use(User);
        Vue.use(Data);
        Vue.use(Rules);
        Vue.use(Config);
        Vue.use(Lodash);
        Vue.use(intersectionObserverProvider);
    },

}
